import { render, staticRenderFns } from "./DigitCodeInput.vue?vue&type=template&id=ef8ce96e&scoped=true&"
import script from "./DigitCodeInput.vue?vue&type=script&lang=js&"
export * from "./DigitCodeInput.vue?vue&type=script&lang=js&"
import style0 from "./DigitCodeInput.vue?vue&type=style&index=0&id=ef8ce96e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8ce96e",
  null
  
)

export default component.exports